import { IFinancingInsight } from "../types/ownerDashboard.types";
import { normalizeKenloPropertyId } from "./buildPropertyLabelMap";

function parseBooleanFlag(value: unknown): boolean {
  return value === true || value === 1 || value === "1" || value === "true";
}

function parseNumericField(value: unknown): number | null {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string" && value.trim().length > 0) {
    const parsed = Number.parseFloat(value);
    return Number.isFinite(parsed) ? parsed : null;
  }

  return null;
}

export function normalizeFinancingInsight(
  insight: IFinancingInsight
): IFinancingInsight {
  const coversInstallment = parseBooleanFlag(insight.covers_installment);
  const coveragePct = parseNumericField(insight.coverage_pct) ?? 0;
  const milestoneProgressPct = parseNumericField(insight.milestone_progress_pct);
  const averageMonthlyNetRent = parseNumericField(insight.average_monthly_net_rent) ?? 0;
  const monthlyInstallment = parseNumericField(insight.monthly_installment) ?? 0;
  const monthlyGap = parseNumericField(insight.monthly_gap) ?? 0;

  const propertyLabel = insight.property_label?.trim();
  const propertyAddress = insight.property_address?.trim();

  return {
    ...insight,
    kenlo_property_id: normalizeKenloPropertyId(insight.kenlo_property_id),
    property_label: propertyLabel || null,
    property_address: propertyAddress || null,
    average_monthly_net_rent: averageMonthlyNetRent,
    monthly_installment: monthlyInstallment,
    monthly_gap: monthlyGap,
    covers_installment: coversInstallment,
    coverage_pct: coversInstallment ? 100 : coveragePct,
    milestone_progress_pct: coversInstallment
      ? 100
      : milestoneProgressPct ?? coveragePct,
  };
}
